import React from "react";
import { useTranslation } from "react-i18next";
import Popup from "components/popup/Popup";

type TEmailBuilderUnavailableMediaModalProps = {
  open: boolean;
  repairedCount: number;
  onClose: () => void;
};

export function EmailBuilderUnavailableMediaModal(
  props: TEmailBuilderUnavailableMediaModalProps,
) {
  const { t } = useTranslation();

  const description =
    props.repairedCount === 1
      ? t(
          "One image or icon in this email is no longer available (for example, removed stock media). It was cleared so you can keep editing. Choose a replacement where needed.",
        )
      : t(
          "{{count}} images or icons in this email are no longer available (for example, removed stock media). They were cleared so you can keep editing. Choose replacements where needed.",
          { count: props.repairedCount },
        );

  return (
    <Popup
      open={props.open}
      type="warning"
      title={t("Missing media removed")}
      description={description}
      backDropCancel={false}
      okText={t("Got it")}
      onOk={props.onClose}
    />
  );
}
